export default __webpack_public_path__ + "static/media/english-to-italian-screenshot-01.e6ec8b0f.png";